import { render } from "./Code.vue?vue&type=template&id=978b5ea4&scoped=true"
import script from "./Code.vue?vue&type=script&lang=ts"
export * from "./Code.vue?vue&type=script&lang=ts"

import "./Code.vue?vue&type=style&index=0&id=978b5ea4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-978b5ea4"

export default script